module.exports = __webpack_public_path__ + "img/about_logo.a3fb680b.png";